import { matchPath } from 'react-router-dom';

/** Set on <html> while a light-only page is shown; index.css pins the app container light. */
export const LIGHT_ONLY_ATTRIBUTE = 'data-light-only';

// Pages owned outside Simplify, which have no dark theme. They paint light content on a
// transparent background, so the dark app container behind them makes a half-themed page.
// Each path also covers everything below it.
const LIGHT_ONLY_PATHS = [
  // CCoE remotes
  '/cloud-management',
  '/api-marketplace',
  '/api-marketplace-mfe',
  // TELUS Translator, under all of its aliases
  '/translations-tool',
  '/telus-translator',
  '/telustranslator',
  '/gpt/copilots/e9c45e40-20f5-4aa1-9bbc-b112739037f5',
  '/multi-language-translation',
  '/sro-portal',
  '/eap-onboard',
  '/metadata-search',
  '/metadataSearchTool',
  // Load balancer requests
  '/lb-request',
  '/haproxy-front-door',
  // starter-kit-forms-mfe
  '/wask',
  '/mfe-lite',
  '/aac-template',
];

/** Whether the page at `pathname` renders light regardless of the user's theme. */
export const isLightOnlyPath = (pathname: string): boolean =>
  LIGHT_ONLY_PATHS.some(path => matchPath({ path, end: false }, pathname));
